import { ClipboardList, BarChart3, ArrowLeftRight, Sparkles } from 'lucide-react';
import './DashboardSidebar.css';

const secciones = [
  { id: 'tareas', label: 'Tablero de tareas', icon: ClipboardList },
  { id: 'estadisticas', label: 'Estadísticas recientes', icon: BarChart3 },
  { id: 'llegadas', label: 'Llegadas y salidas hoy', icon: ArrowLeftRight },
  { id: 'housekeeping', label: 'Housekeeping', icon: Sparkles },
];

function DashboardSidebar({ seccionActiva, onCambiarSeccion, fechaOperativa }) {
  return (
    <aside className="db-sidebar">
      <div className="db-sidebar__header">
        <h2 className="db-sidebar__title">Panel de Control</h2>
        {fechaOperativa && (
          <span className="db-sidebar__fecha">{fechaOperativa}</span>
        )}
      </div>
      <nav className="db-sidebar__nav">
        {secciones.map(({ id, label, icon: Icon }) => (
          <button
            key={id}
            className={`db-sidebar__item ${seccionActiva === id ? 'db-sidebar__item--active' : ''}`}
            onClick={() => onCambiarSeccion(id)}
          >
            <Icon size={18} />
            <span className="db-sidebar__item-label">{label}</span>
          </button>
        ))}
      </nav>
    </aside>
  );
}

export default DashboardSidebar;
